import React from 'react';
import Link from 'gatsby-link';
import { Github } from 'react-feather';

import './_header.scss';

const Header = () =>
  (<header className="header">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="header-content">
            <span className="header-logo">
              <Link to="/">
                <img src="/images/potion.svg" alt="Potion" />
                <strong>POTION</strong>
                <span className="hidden-md"> -- Visualization components and utilities</span>
              </Link>
            </span>
            <nav className="header-nav">
              <ul className="header-nav-list">
                <li className="header-nav-list-item">
                  <Link to="/element/">Elements</Link>
                </li>
                <li className="header-nav-list-item">
                  <Link to="/layout/">Layouts</Link>
                </li>
                <li className="header-nav-list-item">
                  <Link to="/extras/">Extras</Link>
                </li>
                <li className="header-nav-list-item">
                  <Link to="/color/">Colors</Link>
                </li>
                <li className="header-nav-list-item">
                  <Link to="/guides/">Guides</Link>
                </li>
                <li className="header-nav-list-item">
                  <a href="https://github.com/finnfiddle/potion" className="icon-wrap">
                    <Github size={16} />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </header>);

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js